export default new class {

  isInterpretationTree (interpretation) {
    return interpretation === 'tree'
  }

}
